import env from './buildConfig';

const currentSoftwareVersion = {
    vers: env.version
};

export default currentSoftwareVersion; 
